export default e => {
    const target = e.currentTarget || e.target || e.srcElement;
    const rect = target.getBoundingClientRect();

    const x = e.clientX || e.touches[0].clientX;
    const y = e.clientY || e.touches[0].clientY;

    return {
        x: x - rect.left,
        y: y - rect.top,
        rect,
    };
};



// WEBPACK FOOTER //
// ./src/modules/get-mouse-offset-position.js